module.exports = __webpack_public_path__ + "static/img/8.db2e1cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/sp/8.png
// module id = 8XKT
// module chunks = 0